"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.occasionImminentOrOngoing = exports.oneHourInMs = exports.oneDayInMs = exports.threeDaysInMs = exports.EventStatus = void 0;
exports.getEventStatus = getEventStatus;
exports.isOccasionImminentOrOngoing = isOccasionImminentOrOngoing;
var EventStatus;
(function (EventStatus) {
    EventStatus["HAPPENING_LATER"] = "happening_later";
    EventStatus["WITHIN_THREE_DAYS"] = "within_three_days";
    EventStatus["HAPPENING_SOON"] = "happening_soon";
    EventStatus["HAPPENING_NOW"] = "happening_now";
    EventStatus["HAS_ENDED"] = "has_ended";
})(EventStatus || (exports.EventStatus = EventStatus = {}));
exports.threeDaysInMs = 259200000; // Represents 3 days in milliseconds: 3 * 24 * 60 * 60 * 1000
exports.oneDayInMs = 86400000; // Represents 1 day in milliseconds: 24 * 60 * 60 * 1000
exports.oneHourInMs = 3600000; // Represents 1 hour in milliseconds: 1 * 60 * 60 * 1000
exports.occasionImminentOrOngoing = [
    EventStatus.HAPPENING_NOW,
    EventStatus.HAPPENING_SOON,
    EventStatus.WITHIN_THREE_DAYS
];
/**
 * Returns the status of the event.
 *
 * @param occasionData - The occasion data
 * @returns - The status of the event
 */
function getEventStatus(occasionData) {
    if (!occasionData) {
        return null;
    }
    const { startTime, endTime } = occasionData;
    const currentTimeNow = Date.now();
    const startDateTime = new Date(startTime).getTime();
    const endDateTime = new Date(endTime).getTime();
    const threeDaysFromNow = currentTimeNow + exports.threeDaysInMs;
    const oneHourFromNow = currentTimeNow + exports.oneHourInMs;
    if (startDateTime > threeDaysFromNow) {
        return EventStatus.HAPPENING_LATER;
    }
    else if (startDateTime <= threeDaysFromNow && startDateTime > oneHourFromNow) {
        return EventStatus.WITHIN_THREE_DAYS;
    }
    else if (startDateTime <= oneHourFromNow && startDateTime > currentTimeNow) {
        return EventStatus.HAPPENING_SOON;
    }
    else if (currentTimeNow >= startDateTime && currentTimeNow <= endDateTime) {
        return EventStatus.HAPPENING_NOW;
    }
    else {
        return EventStatus.HAS_ENDED;
    }
}
/**
 *
 * @param occasionData - The occasion data
 * @returns If the occasion is imminent or ongoing
 */
function isOccasionImminentOrOngoing(occasionData) {
    const status = getEventStatus(occasionData);
    return exports.occasionImminentOrOngoing.includes(status);
}
//# sourceMappingURL=OccasionTimeHelper.js.map